import {NavigateFunction} from 'react-router-dom';
import {Dispatch, GetState, TempThunkAction} from '../app-types';
import {getActualQueryString} from '../search/search.utils';
import {SearchPageType} from '../search/search-config';
import {fetchFacets, search} from '../search/duck/search-actions';

export const filterFacets = (navigate: NavigateFunction): TempThunkAction => {
    return (dispatch: Dispatch, getState: GetState) => {
        const query: string = getActualQueryString(getState().search[SearchPageType.BASIC]);
        dispatch(fetchFacets(query));
        return dispatch(search(navigate, query, false, false));
    };
};
